import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
// import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css' // Progress 进度条样式
import 'font-awesome/css/font-awesome.min.css'
import '@/styles/index.scss';
import * as filters from '@/filters' // 过滤
import directives from '@/directives' // 指令
import App from './App'
import router from '@/routes' // 路由
import store from '@/stores' // 状态管理
import * as PublicUtil from '@/util/publicUtil' // 公用Util
import components from '@/components' // 全局组件
import '../static/ueditor/ueditor.config.js'
import '../static/ueditor/ueditor.all.min.js'
import '../static/ueditor/lang/zh-cn/zh-cn.js'
import '../static/ueditor/ueditor.parse.min.js'
import echarts from 'echarts'
import commonjs  from '@/config/common.js' // 通用方法
import 'babel-polyfill'
import 'es6-promise/auto'

Vue.prototype.$echarts = echarts
Vue.prototype.$common = commonjs


Vue.config.devtools = true
Vue.config.productionTip = false
Vue.config.debug = true // 开启错误提示
Vue.use(ElementUI)
Vue.use(PublicUtil)
router.afterEach((to,from,next) => {
    window.scrollTo(0,0);
  });
// ------------------------------  注册组件和过滤路由  -------------------------------
// 注册全局组件
Object.keys(components).forEach((key) => {
    var name = key.replace(/(\w)/, (v) => v.toUpperCase()) // 首字母大写
    Vue.component(`v${name}`, components[key])
})

// 注册全局过滤器
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})

// 注册全局指令
Object.keys(directives).forEach(key => {
    Vue.directive(key, directives[key])
})

// ----------------------------  实例化 -----------------------------------------
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js